import Service, { inject as service } from "@ember/service"
import { isNil } from "lodash"
import type EmberStore from "./ember-store"

export default class SessionStore extends Service {
  @service("ember-store") declare store: EmberStore

  _memoryStore: Record<string, string> = {}

  persistObject<T extends object>(key: string, _data: T): T {
    if (typeof _data !== "object") new Error("You can only persist objects through this function.")
    let data = JSON.stringify(_data || {})
    if (window.localStorage) {
      try {
        localStorage.setItem(key, data)
      } catch (error) {
        this._memoryStore[key] = data
        console.log("Error setting local storage.")
        console.log(error)
      }
    }

    return _data
  }

  fetchObject<T extends object>(key: string): T | null {
    let data: string | null | undefined
    if (window.localStorage) {
      data = localStorage.getItem(key)
    } else {
      data = this._memoryStore[key]
    }

    return isNil(data) ? null : (JSON.parse(data!) as T)
  }

  clear(key: string) {
    if (window.localStorage) {
      localStorage.removeItem(key)
    } else {
      delete this._memoryStore[key]
    }
  }
}
